import { CaseRegionModel } from "./case-region.model";

export class AddOrEditCaseRegionModelModel extends CaseRegionModel {
     id: number;
     Name: string;
     description: string;
     isSetAsDefaultRegion: boolean;
}